import { c as _c } from "react/compiler-runtime";
import { IcoShield24 } from '@onefootprint/icons';
import { useTranslation } from 'react-i18next';
type SsnDisclaimerProps = {
  variant: 'ssn4' | 'ssn9' | 'usTaxId';
};
export const SsnDisclaimer = t0 => {
  const $ = _c(21);
  const {
    variant
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "collectData"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  let t2;
  if ($[1] !== t || $[2] !== variant) {
    t2 = () => {
      if (variant === "usTaxId") {
        return t(_temp);
      }
      if (variant === "ssn9") {
        return t(_temp2);
      }
      return t(_temp3);
    };
    $[1] = t;
    $[2] = variant;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const getDescription = t2;
  let t3;
  if ($[4] !== t) {
    t3 = t(_temp4);
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <IcoShield24 color="primary" />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t) {
    t5 = t(_temp5);
    $[7] = t;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t5) {
    t6 = <span className="text-label-2 text-primary">{t5}</span>;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== getDescription) {
    t7 = getDescription();
    $[11] = getDescription;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t7) {
    t8 = <span className="text-body-2 text-secondary">{t7}</span>;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t6 || $[16] !== t8) {
    t9 = <div className="flex flex-col gap-1">{t6}{t8}</div>;
    $[15] = t6;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t3 || $[19] !== t9) {
    t10 = <section aria-label={t3} className="flex gap-3 p-4 bg-secondary rounded-lg w-full">{t4}{t9}</section>;
    $[18] = t3;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
};
function _temp($) {
  return $.fields.ssn.disclaimer.usTaxId;
}
function _temp2($_0) {
  return $_0.fields.ssn.disclaimer.ssn9;
}
function _temp3($_1) {
  return $_1.fields.ssn.disclaimer.ssn4;
}
function _temp4($_2) {
  return $_2.fields.ssn.disclaimer["aria-label"];
}
function _temp5($_3) {
  return $_3.fields.ssn.disclaimer.title;
}